import { BlueprintInstanceType } from '@rta/rta-blueprint-library';
import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { DisplayMode } from '@r-core';

export const insertBacksplashBreakpointMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Add Breakpoint',
		displayModes: [DisplayMode.Backsplash, DisplayMode.BacksplashManufacturing],
		isVisible: ({ controller: { readonly }}): boolean => !readonly,
		onClick: ({ context, refMap, position }): void => {
			if (refMap?.type === BlueprintInstanceType.Backsplash && refMap?.backsplash) {
				// position is global SVG space; the strip is translated to context.center — store the strip-local x so the breakpoint lands where the user clicked
				refMap.backsplash.breakpoints.new(position.x - (context.center?.x ?? 0));
			}
		}
	}
};
